import './cell-tabs.scss';
import classNames from 'classnames';
import React from 'react';
const CellTabs = ({ tabs, activeTabIndex, onTabChange }) => {
    return (React.createElement("div", { className: 'cell-tabs' }, tabs.map((tab, index) => {
        var _a, _b, _c, _d, _e;
        const classification = (_a = tab.classifications) === null || _a === void 0 ? void 0 : _a[0];
        const tabClassName = classNames('cell-tab', {
            active: activeTabIndex === index,
        });
        return React.createElement("div", { key: `${classification.id}-tab`, className: tabClassName, title: (_b = tab.name.split(':')) === null || _b === void 0 ? void 0 : _b[1].trim(), onClick: () => onTabChange(index) },
            React.createElement("div", { className: 'cell-tab-text' }, (_d = (_c = tab.name) === null || _c === void 0 ? void 0 : _c.split(':')) === null || _d === void 0 ? void 0 : _d[1].trim()),
            ((_e = tab.classifications) === null || _e === void 0 ? void 0 : _e.length) > 1 &&
                React.createElement("div", { className: 'cell-tab-count' }, tab.classifications.length));
    })));
};
export default CellTabs;
